/**
 * Formatação e validação de linhas móveis brasileiras.
 *
 * O legado usava jQuery Mask com a máscara `(00) 00000-0000` e o
 * jQuery Validate exigindo exatamente 15 caracteres (o comprimento da máscara
 * cheia), ou seja: DDD + 9 dígitos. Estas funções reproduzem essa regra.
 */

/** Quantidade de dígitos de uma linha móvel válida (DDD + 9 dígitos). */
export const MOBILE_DIGITS = 11;

/** Remove tudo que não é dígito. */
export function onlyDigits(value: string): string {
  return (value || '').replace(/\D/g, '');
}

/**
 * Aplica a máscara `(00) 00000-0000` progressivamente, como o jQuery Mask fazia
 * enquanto o usuário digitava.
 */
export function formatPhone(value: string): string {
  const digits = onlyDigits(value).slice(0, MOBILE_DIGITS);
  if (digits.length <= 2) return digits;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

/**
 * Formata um número já completo para exibição. Diferente de `formatPhone`, só
 * formata quando há dígitos suficientes — senão devolve o valor cru, que é
 * exatamente o comportamento do `$formattedNum` das views Blade.
 */
export function formatPhoneDisplay(value: string | number | null | undefined): string {
  const raw = String(value ?? '');
  const digits = onlyDigits(raw);
  if (digits.length < MOBILE_DIGITS) return raw;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
}

/** `true` quando o número tem DDD + 9 dígitos. */
export function isValidMobile(value: string): boolean {
  return onlyDigits(value).length === MOBILE_DIGITS;
}

/**
 * Compara dois números ignorando máscara. Usado na checagem de integridade
 * entre o número da URL e o número validado na sessão.
 */
export function samePhone(a: string | null | undefined, b: string | null | undefined): boolean {
  const da = onlyDigits(String(a ?? ''));
  const db = onlyDigits(String(b ?? ''));
  return da.length > 0 && da === db;
}
